(function (angular) {
	'use strict';

	var documentLinkListObject = {
		templateUrl: [
			'STATIC_BASE_PATH',
			templateUrlFunction
		],
		bindings: {
			documents: '<'
		},
		controllerAs: 'documentLinkList'
	};

	angular
		.module('productPage')
		.component('documentLinkList', documentLinkListObject);

	function templateUrlFunction(STATIC_BASE_PATH){
		return STATIC_BASE_PATH + '/static/html/reits/product-pages/document-link-list.html';
	}
})(window.angular);